module.exports = __webpack_public_path__ + "static/media/envelope2.a6601ed6.svg";